(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var success = document.querySelector('.contact__success');
    if (success) success.focus();

    var form = document.getElementById('ContactForm');
    if (!form) return;

    var ts = form.querySelector('#ContactFormTs');
    if (ts) ts.value = Date.now();

    form.addEventListener('submit', function (e) {
      var honeypot = form.querySelector('[name="contact[Website]"]');
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }

      if (ts) {
        var elapsed = Date.now() - parseInt(ts.value, 10);
        if (isNaN(elapsed) || elapsed < 3000) {
          e.preventDefault();
          return;
        }
      }
    });
  });
})();
